import { ActionIcon, Box, Button, Center, CloseButton, Divider, Flex, LoadingOverlay, Text } from "@mantine/core";
import { WarningIcon } from "@phosphor-icons/react";
import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { OrderApi } from "../../apis";
import HttpHandler from "../../utils/http-handler";
import { message } from "../../utils/message";
import { renderBusinessName } from "../../utils/render-business-name";
import { FormLayout } from "../layout";

type Props = {
  action?: any;
  setActions?: any;
  reload?: any;
  reviewed?: any;
};

export function BuyerSalesDynamicReviewForm({ action, setActions, reload, reviewed }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation(["order", "common"]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const onSubmit = async (value: string) => {
    setLoading(true);
    try {
      switch (value) {
        case "REJECT": {
          await OrderApi.review(action?.id, {
            review: false,
          });
          setActions([]);
          message.success(t("order:buyerSales.reviewRejectedSuccess"));
          if (reviewed !== "reviewed") {
            reload();
          } else {
            navigate("/buyer-sales");
          }
          break;
        }
        case "CONFIRM": {
          await OrderApi.review(action?.id, {
            review: true,
          });
          setActions([]);
          message.success(t("order:buyerSales.reviewApprovedSuccess"));
          if (reviewed !== "reviewed") {
            reload();
          } else {
            navigate("/buyer-sales");
          }
          break;
        }
      }
    } catch (err) {
      message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <Box mt={20}>
      <FormLayout title={t("order:buyerSales.reviewOrder")} subTitle={t("order:buyerSales.reviewOrderSub")} extra={[<CloseButton key="cancel" onClick={() => setActions([])} />]}>
        <LoadingOverlay visible={loading} />
        <Divider color="gray" my="xs" />
        <Flex style={{ position: "relative" }} direction="column" gap="md">
          <Center>
            <ActionIcon size={100} radius={100} variant="light" color="yellow">
              <WarningIcon size="4.125rem" />
            </ActionIcon>
          </Center>
          <Center>
            <Text fw={500} fz={24} c="gray.7">
              {t("order:buyerSales.reviewConfirmQuestion")}
            </Text>
          </Center>
          <Center>
            <Text w={"540px"} ta="center" color="gray.8" fz={18}>
              {t("order:buyerSales.reviewConfirmDescription", { code: action?.salesCode !== null ? action?.salesCode : action?.purchaseCode, business: renderBusinessName(action?.receiverBusiness) })}
            </Text>
          </Center>

          <Divider color="gray" mt={20} />
          <Flex direction="row" justify="space-between" mb={15}>
            <Button variant="outline" onClick={() => setActions([])}>
              {t("common:actions.cancel")}
            </Button>
            <Flex gap="md">
              <Button
                variant="light"
                color="red"
                onClick={() => {
                  onSubmit("REJECT");
                }}>
                {t("common:actions.reject")}
              </Button>
              <Button
                variant="filled"
                onClick={() => {
                  onSubmit("CONFIRM");
                }}>
                {t("common:actions.approve")}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </FormLayout>
    </Box>
  );
}
